module.exports = __webpack_public_path__ + "img/Img_3.b1ebf72b.jpg";